import React from 'react';
import cn from 'classnames';

import type { Props } from './types';
import styles from './headerSkeleton.module.css';

export const HeaderSkeleton = ({
  isMobile,
  isPreview,
  isWhiteLabel,
}: Props) => (
  <div
    className={cn(styles.headerSkeleton, {
      [styles.mobileHeaderSkeleton]: isMobile,
      [styles.previewHeaderSkeleton]: isPreview,
      [styles.wlHeaderSkeleton]: isWhiteLabel,
    })}
  />
);
